/* eslint-disable no-restricted-globals */
// Copyright (c) 2019 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import { getBasePath } from '../../../shared/services/get-base-path';
import { handleError } from '../../../shared/services/error-handlers';
// import { getUserIdFromSessionStorage } from '../../../shared/services/user-service';

const basePath = getBasePath();
// let loggedInUserId = getUserIdFromSessionStorage()

export async function getAccessPrivileges () {
    // const endPoint = `${basePath}/access-privileges `;
    const endPoint = `${basePath}/access-privileges`;
    const options = {
        method: 'GET',
    };
    try {
        const response = await fetchService.fetch( endPoint, options );
        return response.json();
    } catch ( error ) {
        return handleError( error );
    }
}

// export async function getConfig () {
//     const endPoint = `${basePath}/app-config`;
//     const options = {
//         method: 'GET',
//     };
//     try {
//         const response = await fetchService.fetch( endPoint, options );
//         return response.json();
//     } catch ( error ) {
//         return handleError( error );
//     }
// }

export async function getNotifications () {

    const endPoint = `${basePath}/app-messages `;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }


}

export async function setUserContext ( payload ) {

    const endPoint = `${basePath}/user-context/`;

    const options = {
        body: JSON.stringify( payload ),
        method: 'PUT',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response;

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function deleteUserContext ( ) {

    const endPoint = `${basePath}/user-context`;

    const options = {
        method: 'DELETE',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response;

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getFactories () {

    const endPoint = `${basePath}/factories`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }


}

export async function getAdminFactories () {

    const endPoint = `${basePath}/admin-factories`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }


}

export async function getWorklistFactories () {

    const endPoint = `${basePath}/worklist-factories`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }


}

export async function getProductSeries ( factoryCode ) {

    const endPoint = `${basePath}/product-series?factoryCode=${factoryCode}`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}


export async function getRegion () {

    const endPoint = `${basePath}/region`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }


}

export async function getBranch ( regionCode ) {


    const endPoint = regionCode < 0 || regionCode === undefined || regionCode === '' ? `${basePath}/branch-locations` : `${basePath}/branch-locations?regionCode=${regionCode}`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getFactoryClaim () {

    const endPoint = `${basePath}/factory-claim-types`;


    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getFactoryByCode ( factoryCode ) {

    const endPoint = `${basePath}/factories/${factoryCode}`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getProductSeriesByID ( productSeriesID ) {

    const endPoint = `${basePath}/product-series/ids?productSeriesIds=${productSeriesID}`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getProductSubSeriesByID ( productSubSeriesID ) {

    const endPoint = `${basePath}/product-subseries/${productSubSeriesID}`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getBaseCodeByID ( baseCodeID ) {

    const endPoint = `${basePath}/base-codes/${baseCodeID}`;

    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getDesignModule ( factoryCode ) {

    const endPoint = `${basePath}/design-modules?factoryCode=${factoryCode}`;


    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getMfgModule ( factoryCode ) {

    const endPoint = `${basePath}/manufacturing-modules?factoryCode=${factoryCode}`;


    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export async function getAuditList ( ) {

    const endPoint = `${basePath}/audit`;


    const options = {
        method: 'GET',
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}

export function setDefaultFactoryCode ( factoryCode ) {

    if ( factoryCode === '' ) return false;

    // eslint-disable-next-line no-restricted-globals
    if ( factoryCode.length && !isNaN( factoryCode.charAt( 0 ) ) ) return false;
    localStorage.setItem( 'defaultFactoryCode', factoryCode );
    const defaultFactory = localStorage.getItem( 'defaultFactoryCode' );
    if ( defaultFactory === factoryCode ) return true;
    return false;

}

export function getDefaultFactoryCode ( ) {

    let defaultFactory = localStorage.getItem( 'defaultFactoryCode' );

    if ( !defaultFactory ) {

        defaultFactory = '';

    } else if ( defaultFactory.length && !isNaN( defaultFactory.charAt( 0 ) ) ) {

        defaultFactory = '';
        setDefaultFactoryCode( '' );

    }

    return defaultFactory;

}
